export enum Role {
  Admin = "Admin",
  Director = "Director",
  DataManager = "DataManager",
  BranchManager = "BranchManager",
  Salesperson = "Salesperson",
  TeamOffice = "TeamOffice",
  TeamLeader = "TeamLeader",
}

export const RoleList = [
  Role.Admin,
  Role.Director,
  Role.DataManager,
  Role.BranchManager,
  Role.Salesperson,
  Role.TeamOffice,
  Role.TeamLeader,
];
